module.exports = __webpack_public_path__ + "img/sixday1-2.3e41b322.jpg";